import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        boardName: COMMON.en.boardName,
        forkedFrom: 'Copied from, "{0}"',
        revision: 'Revision {0}'
    }
}

export default TRANSLATIONS